export const GET_AGREEMENT_STATUS = gql`
    query GetAgreementStatus($applicationId: Int!) {
        agreementStatus(applicationId: $applicationId) {
            status
            signers {
                id
                name
                email
            }
            previewUrl
        }
    }
`;
